module.exports = __webpack_public_path__ + "static/media/pearl.6fc15413.jpg";